import { render, staticRenderFns } from "./KusVatDisplay.vue?vue&type=template&id=3fc2b4af"
import script from "./KusVatDisplay.vue?vue&type=script&lang=js"
export * from "./KusVatDisplay.vue?vue&type=script&lang=js"
import style0 from "./KusVatDisplay.vue?vue&type=style&index=0&id=3fc2b4af&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports